
import "jquery.scrollbar";

export module Scrollbar {

	export async function initAllAsync(container: JQuery): Promise<void> {

		var selector = ".scrollbar";

		var count = container.find(selector).length;
		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find(selector), async (i, e) => {
				var scrollbar = new Scrollbar($(e));
				await scrollbar.initAsync();
				count -= 1;
				if (count == 0)
					resolve();
			});

			//container.find(selector).each(async function () {
			//	var scrollbar = new Scrollbar($(this));
			//	await scrollbar.initAsync();
			//	count -= 1;
			//	if (count == 0)
			//		resolve();
			//});

		});

	}


	export class Scrollbar {

		private elemenet: JQuery;


		constructor(element: JQuery) {
			this.elemenet = element;
		}

		public initAsync(): Promise<void> {
			var options = <ScrollbarOptions>{
				disableBodyScroll: true,
				autoUpdate: true
			};

			return new Promise<void>((resolve, reject) => {
				this.elemenet.scrollbar(options);
				resolve();
			});

		}

	}

}
